<template>

<div class="equipmentCatalogPage">

    <!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">

        <!-- page-heading -->
        <page-heading :show="true" :pageTitle="title"></page-heading>

        <div class="columns">

            <div class="col-main">

				<div class="filterBar is-clearfix">

					<form-input inputType="text" label="ECP-TITLE" inputSize="is-default" minWidth="300px" v-model="ecp.title"></form-input>

					<form-input inputType="select" label="ECP-SECTION" :showLabelInOptions="false" inputSize="is-default" minWidth="200px" v-model="ecp.section" :selectOptions="ecSections"></form-input>

					<!-- status -->
					<div class="control">
						<div class="control-label">
							<label-name labelKey="PAGE-STATUS"></label-name>
						</div>
						<div class="control">
							<status-dropdown type="equipmentCatalogPageStatus" label="ECP-SELECT-STATUS-" :data.sync="ecp.status" class="ecp small"></status-dropdown>
						</div>
					</div>

					<!-- isIntroPage -->
					<div class="control">
						<div class="control-label">
							<label-name labelKey="ECP-IS_INTRO_PAGE" title="Handelt es sich bei dieser Seite um eine Intro Seite?"></label-name>
						</div>
						<div class="control">
							<b-switch v-model.sync="ecp.isIntroPage" type="primary" class="is-small"></b-switch>
						</div>
					</div>

					<div class="control" style="min-width: 100%; margin-top: 12px;">

						<div class="control-label">
							<label-name labelKey="ECP-CATEGORY_ALIASES"></label-name>
						</div>
						<div class="control">

							<multiselect
								v-model="categoryExistingTags"
								tag-placeholder="als neuen Alias speichern"
								selectedLabel="ausgewählt"
								selectLabel="Enter für Auswahl"
								deselectLabel="Enter für Entfernen"
								placeholder="Suchbegriff eingeben"
								label="name"
								track-by="name"
								:options="categoryTagsOptions"
								:multiple="true"
								:taggable="true"
								:optionsLimit="5"
								@tag="categoryTagAdd"
								@select="categoryTagSelect"
								:blockKeys="['Delete']"
								class="tagging">

									<template slot="tag" slot-scope="props">

										<template v-if="props.option.$isDisabled == true">

											<span class="custom__tag disabled">
												<span>{{ props.option.name }}</span>
											</span>

										</template>

										<template v-else>

											<span class="custom__tag">
												<span>{{ props.option.name }}</span>
												<span class="custom__remove" @click="props.remove(props.option)">
													<span class="icon is-small"><i class="fa fa-remove"></i></span>
												</span>
											</span>

										</template>


									</template>

							</multiselect>

						</div>


					</div>

				</div>


				<!-- Page Wrapper -->
				<div class="pageWrapper">

					<div id="page" :class="[{'isLeftPage': isLeftPage }, { 'isIntroPage': ecp.isIntroPage }, getSectionClass()]">

						<!-- page LOGO -->
						<div class="pageLogo">

						</div>


						<div class="pageSection" :style="{'background-color': ecpSectionColor }">
							<div v-if="ecp.section != null">{{ ecp.section.name }}</div>
						</div>

						<div class="pageInner">

							<!-- page TITLE -->
							<div class="pageTitleWrapper">
								<div class="pageTitle">{{ ecp.title }}</div>
							</div>


							<template v-if="ecp.isIntroPage === false">

								<div id="target" class="content" @dragleave="onDragLeave($event)" @dragover.prevent="onDragOver($event)" @drop="onDrop($event)">

									<draggable
						                v-model="ecp.elements"
						                :options="{
						                    handle: '.drag',
											draggable: '.section',
						                }"
										@sort="onDragComplete($event)">

										<transition-group>

											<!-- :class="['section', pageElement.type.name]" -->
											<div v-for="(pageElement, index) in ecp.elements" :key="pageElement" v-if="ecp.elements.length > 0" :class="['section', pageElement.type.name]">

												<!-- CATEGORY -->
												<template v-if="pageElement.type.name == 'CATEGORY'">

													<cpe-category :element="pageElement" :elements="ecp.elements" :elementIndex="index" @updateTags="updateTags" @save="submitForm(false)"></cpe-category>

													<div class="section" v-if="pageElement.showCategoryContent">
														<cpe-content :element="pageElement"></cpe-content>
													</div>

												</template>

												<!-- IMAGE -->
												<template v-if="['BANNER', 'FULLSIZE_AD'].indexOf(pageElement.type.name) > -1">
													<cpe-picture :element="pageElement"></cpe-picture>
												</template>

												<!-- CONTENT: RICH TEXT -->
												<template v-if="pageElement.type.name == 'CONTENT'">
													<cpe-content :element="pageElement"></cpe-content>
												</template>

												<!-- TOOLBAR -->
												<div class="aside">

											        <div class="toolbar">

														<span class="icon drag" title="verschieben" v-if="pageElement.type.name!='FULLSIZE_AD'"><i class="icon-ak-move"></i></span>
											            <span class="icon" @click="sectionDelete(index)" title="entfernen"><i class="icon-ak-entfernen"></i></span>

														<!-- additional buttons for category sections -->
														<template v-if="pageElement.type.name == 'CATEGORY' && ecp.elements[index].category">

															<div class="toolbar-section featureSection">

																<!-- show images button -->
																<span :class="[{ 'is-disabled': pageElement.categoryHasImages == null ? true : !pageElement.categoryHasImages }, { 'is-active': pageElement.showCategoryImages }, icon]" @click="toggleCategoryImagesVisibility(index)" title="zeige/verstecke Bilder"><i class="fa fa-image"></i></span>

																<!-- show content button -->
																<span :class="[{ 'is-active': pageElement.showCategoryContent }, {'hasContent': hasContent(pageElement) }, 'icon']" @click="toggleCategoryContentVisibility(index)" title="zeige/verstecke Inhalt">
																	<i class="fa fa-font"></i>
																</span>

															</div>
															<!-- <pre>{{ pageElement.displayedEquipment }}</pre> -->
															<div class="toolbar-section imagesSizeSection" v-if="pageElement.categoryHasImages!=null && pageElement.showCategoryImages">

																<span title="kleine Bildleiste" :class="[{ 'is-active': pageElement.imageSize == 'S' || pageElement.imageSize == '' }]" @click="setCategoryImagesSize(index, 'S')">
																	<i class="icon-ak-bild-klein" />
																</span>
																<span title="große Bildleiste" :class="[{ 'is-active': pageElement.imageSize == 'L' }, { 'is-disabled': pageElement.displayedEquipment.filter(_=>_.equipment != null).length > 3 }]" @click="setCategoryImagesSize(index, 'L')">
																	<i class="icon-ak-bild-gross" />
																</span>

															</div>

															<div class="toolbar-section madeInSection ">
																<span v-for="state in madeInStates" :key="state" :title="'Hergestellt in \''+state.title+'\''" :class="[{ 'is-active': pageElement.madeIn == state.value }]" @click="pageElement.madeIn=state.value">
																	<img :src="state.iconUrl" />
																</span>
															</div>

														</template>



											        </div>

												</div>



											</div>

										</transition-group>

									</draggable>


								</div>

							</template> <!-- // isIntroPage === false -->


							<!-- isIntroPage === true -->
							<template v-else>

								<div id="target" class="content">
									<cpe-picture :element="ecp" type="INTRO_PAGE"></cpe-picture>
								</div>

							</template>


						</div>


						<div id="pageFooter">
							<div class="pageNumber">{{ parseInt(ecp.pageIndex) + 1 }}</div>
						</div>


					</div>

				</div>

            </div>


            <div class="col-aside">

				<affix :offset="50">

					<custom-button type="blue" icon="icon-ak-speichern" name="ECP-BTN_SAVE" :loading="isSaving" @click.native="submitForm(true)" :class="{'is-disabled': isReadOnly}"></custom-button>

					<div class="sidebox" v-if="ecp.isIntroPage === false">

						<div class="heading"><lang labelKey="ECP-SIDEBAR-HEADLINE-TYPES"></lang></div>

						<div class="types">

							<div v-for="(type, index) in equipmentCatalogPageElementTypes" :data-type="type.name" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang :labelKey="'ECP-TYPE-'+type.name"></lang>
							</div>

							<div data-type="EQUIPMENT" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="ECP-TYPE-EQUIPMENT"></lang>
							</div>

						</div>

					</div>


					<!--
					<div class="sidebox" v-if="ecp.isIntroPage === false && ['matthias'].indexOf(activeUser.username) > -1">

						<div class="heading"><lang labelKey="ECP-SIDEBAR-HEADLINE-TEMPLATES"></lang></div>

						<div class="types templates">

							<div data-type="CONTENT" data-template="template-1" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 1"></lang>
							</div>

							<div data-type="CONTENT" data-template="template-2" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 2"></lang>
							</div>

							<div data-type="CONTENT" data-template="template-3" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 3"></lang>
							</div>

							<div data-type="CONTENT" data-template="template-4" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 4"></lang>
							</div>

							<div data-type="CONTENT" data-template="template-5" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 5"></lang>
							</div>

							<div data-type="CONTENT" data-template="template-6" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 6"></lang>
							</div>

							<div data-type="CONTENT" data-template="template-7" draggable="true" @dragend="onDragEnd($event)" @dragstart="onDragStart($event)">
								<lang labelKey="TPL 7"></lang>
							</div>

						</div>

					</div>
					-->

					<div class="multiple">
						<custom-button name="ECP-BTN-PREVIEW" type="dark" icon="fa fa-file-text" @click.native="loadPreview"></custom-button>
						<export-button :exportId="ecp.id" export="equipmentCatalogPage"></export-button>
					</div>

					<router-link :to="{ name: 'equipmentCatalogPageChangeLog', props: { 'equipmentCatalogPageID': ecp.id }}" v-if="userRole == 'Administrator'">
						<custom-button name="ECP-BTN-CHANGELOG" type="dark" icon="icon-ak-history"></custom-button>
					</router-link>

				</affix>


            </div>

        </div>



		<!-- MODAL for PREVIEW -->
		<modal
			:title="$t('ECP-MODAL-TITLE-PREVIEW')"
			cancel-text="Abbrechen"
			transition="fadeDown"
			:show-ok="false"
			:is-show="showModalPreview"
			:backdrop-closable="false"
			:show-footer="false"
			@close="onCloseModalPreview"
			class="ecpPreview vcenter">


            <template v-if="!previewLoaded">

                <loading-indicator-small></loading-indicator-small>

            </template>

			<template v-else>

				<img class="previewImage lazy-img-fadein" v-lazy="previewImage" />

			</template>

		</modal>

    </template>


</div>


</template>


<script>
import draggable from 'vuedraggable';
import statusDropdown from '../utils/incl-statusDropdown';
import cpeCategory from './CatalogPageElementCategory';
import cpePicture from './CatalogPageElementPicture';
import cpeContent from './CatalogPageElementContent';
import Multiselect from 'vue-multiselect';

import exportButton from '../utils/exportButton';


export default {

    name: 'equipmentCatalogPage',

	components: {
		draggable,
		statusDropdown,
		cpeCategory,
		cpePicture,
		cpeContent,
		Multiselect,
		exportButton
	},

	data() {

		var self = this;

		return {

			showSource: false,
			isSaving: false,
            isLoading: false,
            ecp: null,
			ecSections: null,

			categoryTagsOptions: [],
			categoryExistingTags: [],

			isNewEquipmentCatalogPage: false,
			showCategoryContent: false,
			showModalPreview: false,
			previewLoaded: false,
			previewImage: null
        }

    },

    created() {

		// existing page - fetch the page ID from router
		if(this.$route.params.equipmentCatalogPageID && Number.isInteger(parseInt(this.$route.params.equipmentCatalogPageID)) ) {

			this.fetchData();

		}

		// new page
		else {

			// fetch catalogSections
			// this.fetchCatalogSections();

			this.fetchData2();

			this.isNewEquipmentCatalogPage = true;

			// create new catalog page obj with default values
			this.ecp = {
				catalog: this.equipmentCatalogId,
				categoryAliases: [],
			    title: "",
				isIntroPage: false,
				sortorder: null,
				section: null,
				elements: []
			}

		}

    },

	watch: {

	},


	computed: {

		madeInIcon() {

            let img = "";

            switch(this.element.madeIn) {
                case 'AT': img = "at"; break;
                case 'DE': img = "de"; break;
                case 'EU': img = "eu"; break;
                default: img = "nowhere";
            }

            return require(`@/assets/img/madeInIcons/${img}.svg`);
        },


		isLeftPage() {
			return this.ecp.sortorder % 2 != 0;
		},

		title() {

			if(this.isNewEquipmentCatalogPage == true) {
				return "ECP-HEADER-NEW_PAGE";
			} else {
				return 'Seite ' + (parseInt(this.ecp.pageIndex) + 1) + ': ' + this.ecp.title;
			}
		},

		ecpPageTitle() {

			return "test: " + this.ecp.title.trim();

		},

		ecpSectionColor() {

			return this.ecp.section != null ? this.ecp.section.color : '#f0f0f0';

		},

		equipmentCatalogPageElementTypes() {

			return this.$store.getters.getTermsByTaxonomy('EQUIPMENT_CATALOG_PAGE_ELEMENT_TYPES');

		},


		madeInStates() {

			// return [null, 'EU','AT','DE'];
			return [
				{
					value: null,
					iconUrl: require(`@/assets/img/madeInIcons/nowhere.svg`),
					title: 'Keine Zuordnung',
					// iconUrl: '~@/assets/img/madeInIcons/nowhere.svg',
				},
				{
					value: 'AT',
					iconUrl: require(`@/assets/img/madeInIcons/at.svg`),
					title: 'AT',
				},
				{
					value: 'DE',
					iconUrl: require(`@/assets/img/madeInIcons/de.svg`),
					title: 'DE',
				},
				{
					value: 'EU',
					iconUrl: require(`@/assets/img/madeInIcons/eu.svg`),
					title: 'EU',
				},

			]


		}


	},

    mounted() {

    },

    methods: {

		getSectionClass() {

			if(this.ecp && this.ecp.section) {
				return 'section-'+this.ecp.section.id;
			}

		},

		updateTags(tag) {

			this.categoryExistingTags.push(tag);
			this.categoryTagsOptions.push(tag);
		},

		categoryTagAdd(newTag) {

			let tag = { name: newTag }
			this.categoryTagsOptions.push(tag);
			this.categoryExistingTags.push(tag);

		},

		categoryTagSelect(selectedOption) {

			// this.categoryExistingTags.push(selectedOption);

		},


		loadPreview() {

			this.showModalPreview = true;

			if(this.previewLoaded) {
				return true;
			}

			var self = this;
			this.axios.get(this.$config.api + 'equipmentCatalogPage/'+this.ecp.id+'/document?link=1&image=1')
				.then(function(response) {

					self.previewImage = self.$config.assets + response.data.equipmentCatalogPage.dir + '/' + response.data.equipmentCatalogPage.filename;
					self.previewLoaded = true;

				});
		},

		onCloseModalPreview() {

			this.showModalPreview = false;
			// this.previewLoaded = false;

		},


		hasContent(pageElement) {

			return (pageElement.content == null || pageElement.content == "") ? false : true;

		},

		submitForm(refreshThumb=false) {

			// make sure the new page has a section assigned
			if(this.ecp.section == null) {
				this.$notify.open( {content: this.$t('ECP-MSG-ADD_SECTION_FIRST'), type: 'warning'} );
				return;
			}

			var self = this;

			var categoryAliases = this.ecp.categoryAliases;
			this.ecp.categoryAliases = [];

			this.categoryExistingTags.forEach(function(tag, index) {

				if(!tag.$isDisabled) {

					let obj = categoryAliases.find(function(i) {
						return i.alias.id == tag.id;
					});

					if(!obj) {
						obj =  {
							page: self.ecp.id,
							alias: tag
						}
					}

					self.ecp.categoryAliases.push(obj);

				}

			});


			this.isSaving = true;
			return new Promise((resolve, reject) => {

				let refreshThumbnail = refreshThumb ? 1 : 0;

				this.entityCreateOrUpdate('equipmentCatalogPage', self.ecp, { isSilent: false, getParams: 'refreshThumbnail='+refreshThumbnail, msg: 'ECP-MSG-PAGE_SUCCESSFULLY_SAVED' })
					.then(function(response) {

						// if this was an insert (completely new page)
						// we assign the new id from the response
						if(self.isNewEquipmentCatalogPage == true) {
							self.ecp.id = response.id;
						}

						self.isSaving = false;

						resolve();

					});

			})

		},

		fetchData() {

			var self = this;
			let equipmentCatalogPageID = this.$route.params.equipmentCatalogPageID;
            this.isLoading = true;

            // fetch "cover", "u4", "lesezeichen"
            function getSections() {
                return self.axios.get(self.$config.api + 'equipmentCatalogSection?orderBy=sortorder');
            }

			function getEquipmentCategoryAlias() {
				return self.axios.get(self.$config.api + 'equipmentCategoryAlias');
			}

            // fetch sections
            function getEquipmentCatalogPage() {
				return self.axios.get(self.$config.api + 'equipmentCatalogPage/'+equipmentCatalogPageID+'?include=equipmentCatalogPage.elements,equipmentCatalogPage.asset,equipmentCatalogPageElement.displayedEquipment,equipmentCatalogPageElementDisplayedEquipment.equipment,equipmentCatalogPageElement.type,equipmentCatalogPageElement.category,equipmentCatalogPageElement.asset,equipmentCatalogPage.section,equipmentCatalogPage.categories,equipmentCatalogPageCategory.category,equipmentCategory.products,equipmentCategoryEquipment.equipment,equipment.asset,equipmentCatalogPage.status,equipmentCatalogPage.categoryAliases,equipmentCategoryAliasEquipmentCatalogPage.alias&orderBy=equipmentCatalogPageElement.sortorder,equipmentCatalogPageElementDisplayedEquipment.sortorder');
			}

            this.axios.all([getSections(), getEquipmentCategoryAlias(), getEquipmentCatalogPage()])
              .then(self.axios.spread(function (sections, aliases, catalogPage) {

				  	// assign page data
					self.ecp = catalogPage.data;

					// assign equipmentCatalogSections
					self.ecSections = sections.data.equipmentCatalogSection;

					// loop through all ellements and their categories
					// in order to get the category aliases tags
					catalogPage.data.elements.forEach(function(elem) {

						if(elem.category && elem.category.aliases) {
							elem.category.aliases.forEach(function(tag, index) {
								tag.alias.$isDisabled = true;
								self.categoryExistingTags.push(tag.alias);
							})
						}
					})

					// fill existing tags array
					catalogPage.data.categoryAliases.forEach(function(elem) {
						self.categoryExistingTags.push(elem.alias);
					})

					// fill options array for tags
					self.categoryTagsOptions = aliases.data.equipmentCategoryAlias;
					self.categoryTagsOptions.forEach(function(option, index) {

						let found = self.categoryExistingTags.find(function(i) {
							return i.$isDisabled && i.id == option.id;
						});

						if(found) {
							option.$isDisabled = true;
						}

					})

					self.isLoading = false;

				}));

		},

		/*
		fetchCatalogSections() {

			this.isLoading = true;
			var self = this;

			this.axios.get(self.$config.api + 'equipmentCategoryAlias')

                .then(function(response) {

					self.ecSections = response.data.equipmentCatalogSection;
					self.categoryTagsOptions = response.data.equipmentCategoryAlias;
					self.isLoading = false;

                }).catch(function(error) {
                    self.isLoading = false;
					console.log(error);
				});

		},
		*/

		fetchData2() {

			var self = this;
            this.isLoading = true;

            // fetch "cover", "u4", "lesezeichen"
            function getSections() {
                return self.axios.get(self.$config.api + 'equipmentCatalogSection?orderBy=sortorder');
            }

			function getEquipmentCategoryAlias() {
				return self.axios.get(self.$config.api + 'equipmentCategoryAlias');
			}

            this.axios.all([getSections(), getEquipmentCategoryAlias()])
              .then(self.axios.spread(function (sections, aliases) {

					self.ecSections = sections.data.equipmentCatalogSection;
					self.categoryTagsOptions = aliases.data.equipmentCategoryAlias;

					self.isLoading = false;

				}));

		},

		toggleCategoryImagesVisibility(index) {

			this.ecp.elements[index].showCategoryImages = !this.ecp.elements[index].showCategoryImages;

		},

		setCategoryImagesSize(index, type="S") {

			this.ecp.elements[index].imageSize  = type;

		},

		toggleCategoryContentVisibility(index) {

			if(this.ecp.elements[index].showCategoryContent == null) {
				this.$set(this.ecp.elements[index], 'showCategoryContent', false);
			}

			this.ecp.elements[index].showCategoryContent = !this.ecp.elements[index].showCategoryContent;

		},

		sectionDelete(index) {

            var self = this;

            this.$modal.confirm({
                title: "Löschbestätigung",
                content: 'Soll dieser Bereich wirklich entfernt werden?',
                onOk: function() {
                    self._deleteSection(index);
                },
                okText: self.$t('löschen'),
                cancelText: self.$t('abbrechen')
            });

        },

        _deleteSection(index) {

            this.ecp.elements.splice(index, 1);

        },

		onDragLeave(ev) {

			$(ev.target).removeAttr('drop-active');

	  	},

		onDragOver(ev) {

			$(ev.target).attr('drop-active', true);
		    ev.preventDefault();

		},

		onDrop(ev) {

		    ev.preventDefault();
			let target = ev.target || ev.srcElement;
			$(target).removeAttr('drop-active');

			// get transferedData
			let transferedData = JSON.parse(ev.dataTransfer.getData('text/plain'));
			let type = transferedData.type.toUpperCase();
			let template = typeof transferedData.template != 'undefined' ? transferedData.template.toUpperCase() : null;

			// check if dragged element comes from the "type box"
			if(['CATEGORY', 'CONTENT', 'BANNER', 'FULLSIZE_AD'].indexOf(type) == -1) {
				return false;
			}

			/*
			// check if there already are any elements on the page
			if(this.ecp.elements.length > 0) {

				for(var i=0; i < this.ecp.elements.length; i++) {

					// echo a warning when there was a FULLSIZE_AD section found on the page (no place left ..)
					if(this.ecp.elements[i].type.name == 'FULLSIZE_AD') {
						this.$notify.open( {content: this.$t('ECP-MSG-REMOVE_FULLSIZE_AD_FIRST'), type: 'warning'} );
						return;
					}

				}

			}
			*/


			// if a fullsize_ad should be applied,
			// there must not be any other sections on the page
			if(type == 'FULLSIZE_AD' && this.ecp.elements.length > 0) {

				this.$notify.open( {content: this.$t('ECP-MSG-APPLY_ON_BLANK_PAGE_ONLY'), type: 'warning'} );

			// all other elements
			} else {

				var content = "";
				/*
				if(template != null) {

					switch(template) {

						case "TEMPLATE-1":
							content = '<p>Sehr geehrte Frau Apotheker, &nbsp;<br>sehr geehrter Herr Apotheker,&nbsp;</p><p>nun stellt sich die Frage der Überprüfung / Wartung des Sicherheitsschranks.</p><p>Die Hersteller empfehlen eine jährliche Prüfung.</p><p>(z.B. den Filter des UFA sollte regelmäßig getauscht werden.)&nbsp;</p><p><br></p><p>In der Beilage befinden sich drei Varianten, die wir in Zusammenarbeit mit der Firma&nbsp;</p><p><br></p><p>Ing. Linder KG Labortechnik<br>Czerningasse 18<br>1020 Wien</p><p>Tel: 01/214 01 05<br>01/216 29 70<br>Fax:01/216 29 70 10</p><p>E-Mail: office@linder-labortechnik.at&nbsp;</p><p>anbieten wollen.&nbsp;</p><p><br></p><p>Für weitere Fragen stehen wir Ihnen jederzeit gerne zur Verfügung.&nbsp;</p><p><br></p><p><br></p></div>';
							break;

						case "TEMPLATE-2":
							content = '<table class="" style="width: 100%;"><tbody><tr><td style="width: 50%; vertical-align: middle; text-align: center;">Zelle1</td><td style="width: 50%; text-align: center; vertical-align: middle;"><br><br>Zelle2<br><br><br></td></tr></tbody></table><p><br></p><p><strong>TEST TEST</strong></p><p><br></p><p><em>Und hier ein bisschen kursiver Text</em><em>​​</em><br></p></div>';
							break;

						case "TEMPLATE-3":
							content = '<p>'+template+'</p>';
							break;

						case "TEMPLATE-4":
							content = '<p>'+template+'</p>';
							break;

						case "TEMPLATE-5":
							content = '<p>'+template+'</p>';
							break;

						case "TEMPLATE-6":
							content = '<p>'+template+'</p>';
							break;

						case "TEMPLATE-7":
							content = '<p>'+template+'</p>';
							break;

						default:
							content: "";

					}

				}
				*/

				let newElement = {
					id: null,
					sortorder: this.ecp.elements.length,
					content: content,
					asset: null,
					page: this.$route.params.equipmentCatalogPageID,
					type: this.equipmentCatalogPageElementTypes[type],
					madeIn: null,
					imageSize: 'S',
					displayedEquipment: [],
					category: null
				}

				this.ecp.elements.push(newElement);

			}



		},

		onDragEnd(ev) {

			// reset border and background of dragged element
			ev.currentTarget.style.border = '';
			ev.currentTarget.style.background = '';
			ev.currentTarget.classList.remove("dragging");

		},

		onDragStart(ev) {

			var target = ev.target || ev.srcElement;

		    // Change the source element's background color to signify drag has started
			target.style.border = 'dashed';
			target.style.background = '#dbf3ff';
			target.classList.add("dragging");

			// set effect type
			ev.dataTransfer.effectAllowed = 'copy';

			// Set the drag's format and data. Use the event target's id for the data
			let data = JSON.stringify(target.dataset);

			// Set the drag's format and data. Use the event target's id for the data
			ev.dataTransfer.setData('text/plain', data);

		},


		// this is for vertical moving (vue draggable)
		onDragComplete(ev) {

			this.ecp.elements.forEach(function(prop, index) {
				prop.sortorder = index;
			});

		},

    },

	beforeRouteLeave (to, from, next) {

		// save before leaving ...
		if(to.name == "equipment" || to.name == "equipmentCategory") {

			this.submitForm().then(() => {
				next();
			});

		} else {

			next();

		}

    }


}


</script>

<style lang="scss" scoped>

	.pageWrapper {
		position: relative;
		z-index: 1;
		width: 100%;
		background-color: #f5f7f9;
		padding: 25px 0;

		#page {
			position: relative;
			z-index: 1;
			background: #f1f1f1;
			width: 210mm;
			height: 297mm;
			margin: 0 auto;
			border: 1px #ccc solid;
			background: white;
			-webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
			-moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
			box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
			color: #999;


			.pageLogo {
				position: absolute;
				top: 13mm;
				width: 45mm;
				right: 20mm;
				height: 15mm;
				background-size: contain;
				background-repeat: no-repeat;
				background-image: url('../../assets/img/HerbaBringtsLogoRGB.png');
				background-position: 50% 50%;
			}

			.pageSection {
				position: absolute;
				top: 0;
				right: 3mm;
				width: 60mm;
				height: 3mm;
				background: #ddd;
				-webkit-transform: rotate(-90deg);
				-moz-transform: rotate(-90deg);
				-o-transform: rotate(-90deg);
				-ms-transform: rotate(-90deg);
				transform: rotate(-90deg);
				transform-origin: top right;

				> div {
					position: absolute;
					left: 0;
					right: 0;
					top: -6.5mm;
					bottom: 0;
					font-size: 11pt;
					color: #9b9b9b;
				}
			}


			/* Emballagen */
			&.section-1 .pageSection  {

			}

			/* Standgefäße */
			&.section-2 .pageSection  {
				top: 60mm;
			}

			/* Rezepturen */
			&.section-3 .pageSection  {
				top: 120mm;
			}

			/* Großgeräte */
			&.section-15 .pageSection  {
				top: 180mm;
			}

			/* Dienstleistungen */
			&.section-6 .pageSection  {
				top: 236.5mm;
			}
			&.section-6 .pageSection > div {
				left: 28px;
			}


			/* U3/U4*/
			&.section-14 .pageSection  {

			}

			&.isIntroPage .pageSection {
				border-top-left-radius: 10px;
			}
			&.isIntroPage:not(.section-1) .pageSection {
				border-top-right-radius: 10px;
			}
			&.isIntroPage.section-6 .pageSection {
				border-top-left-radius: 0;
				border-top-right-radius: 10px;
			}



			&.isIntroPage {

				.pageSection {
					right: 11mm;
					height: 11mm;
					border-top-left-radius: 10px;

					> div {
						top: 2.4mm;
						left: 14px;
						font-size: 18px;
						color: #FFF;
					}

				}

			}

			&.isLeftPage {

				.pageLogo {
					visibility: hidden;
				}

				.pageSection {
					display: none;
					/*
					transform: rotate(90deg);
					transform-origin: left top;
					left: 0;
					right: auto;

					transform-origin: left;
				    left: 1.5mm;
				    top: -1.5mm;

					> div {
						left: auto;
					}
					*/
				}
			}

			> .pageInner {

				position: absolute;
				top: 33mm;
				right: 20mm;
				bottom: 20mm;
				left: 20mm;

				.pageTitleWrapper {
					position: absolute;
					width: 100%;
					height: 0;
					top: 0;

					.pageTitle {
						position: absolute;
						left: 0;
						bottom: 0;
						/*font-size: 18pt;*/
						font-size: 16pt;
						line-height: 19pt;
						color: #000;
						max-width: 66%;
					}

				}

				> .content {
					position: absolute;
					/* top: 8mm; */
					top: calc(8mm - 2px);
					left:0;
					right: 0;
					bottom:0;
					border: 2px dashed #eee;
					transition: all .3s ease;

					&[drop-active=true] {
						border-color: #888;
						background: #f2fbff;
					}
				}

			}





		}


    }



	#pageFooter {

		position: absolute;
		bottom: 10mm;
		left: 0;
		right: 0;
		font-size: 12px;
		display: flex;
		flex-wrap: nowrap;

		.pageNumber {
			flex: 1;
			text-align: center;
			font-size: 11pt;
		}

	}



	@media all and (max-width: 1280px) {

		.pageWrapper .page {

			width: 150mm;
			height: 127mm;
		}

	}

	@media all and (max-width: 1024px) {

		.pageWrapper .page {

			width: 100mm;
			height: 127mm;
		}

	}
	.equipmentCatalogPage {
		.tagging {
			width: auto;
			.custom__tag {
				position: relative;
				display: inline-block;
				margin: 0 3px 0 0;
				border-radius: 3px;
				line-height: 1;
				background: #eaeaea;
				color: #222;
				white-space: nowrap;
				overflow: hidden;
				max-width: 100%;
				text-overflow: ellipsis;
				text-align: center;
				font-size: 12px;
				padding: 4px 8px;

				&.disabled {
					background: #eaeaea;
					color: #bbb;
				}

				.custom__remove {
					cursor: pointer;
					.icon.is-small {
						font-size: 8px;
						height: auto;
						width: 12px;
						line-height: inherit;
						color: #888;
					}
					&:hover .icon.is-small {
						color: #000;
					}
				}

			}
		}
	}


	/* sectionAside: TOOLBAR */
	.equipmentCatalogPage .section .aside {

		position: absolute;
		z-index: 0;
		top: 0;
		right: 0;
		bottom: 0;
		left: calc(100% + 21.5mm);
		width: 15mm;

		display: flex;
		align-items: center;
		justify-content: center;
		/*padding: 0 2px;*/
		padding: 0;

		.toolbar {

			background: #fff;
			border-radius: 10px;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			padding: 10px 2px;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			align-items: center;

			min-width: 65px;

			span {
				color: #bbb;
				transition: color .2s ease;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 22px;
				height: 22px;
				font-size: 13px;


				&.is-disabled {
					color: #f0f0f0;
				}
				&.is-active {
					color: #000;
				}
				&.hasContent {
					color: orange;
				}
				&:hover {
					color: #000;
				}
				&:not(:last-child) {
					margin-bottom: 2px;
				}
				&.drag {
					cursor: grab;
				}

			}

			.toolbar-section {

				display: flex;
				margin: 3px 0;

				span {

					margin: 0 !important;
					background-color: #F0F0F0 !important;
					transition: all .3s ease;

					&:hover,
					&.is-active {
						background-color: #DDD !important;
					}

				}

				&.featureSection {


					span {

						&:first-child {
							border-top-left-radius: 6px;
							border-bottom-left-radius: 6px;
						}
						&:last-child {
							border-top-right-radius: 6px;
							border-bottom-right-radius: 6px;
						}
					}

				}


				&.imagesSizeSection {

					align-items: center;
				    justify-content: center;

					i {
						color: #000;
						font-size: 16px;
					}

					span {

						&:first-child {
							border-top-left-radius: 6px;
							border-bottom-left-radius: 6px;
						}
						&:last-child {
							border-top-right-radius: 6px;
							border-bottom-right-radius: 6px;
						}

						&.is-disabled {
							i {
								color: #aaa;
							}
						}
					}

				}

				&.madeInSection {

					/*flex-direction: column;*/
					flex-wrap: wrap;
					justify-content: center;

					background: transparent;

					img {
						width: 16px;
						height: 16px;
					}

					span {

						&:first-child {
							border-top-left-radius: 6px;
						}
						&:nth-child(2) {
							border-top-right-radius: 6px;
						}
						&:nth-child(3) {
							border-bottom-left-radius: 6px;
						}
						&:last-child {
							border-bottom-right-radius: 6px;
						}
					}


				}
			}

		}


	}




</style>



<style>





	.fr-command i {
		vertical-align: middle !important;
	}

	@font-face {
	    font-family: "theSans";
	    src:url("../../assets/fonts/thesans-b3light.otf");
	    font-weight: 300;
	}
	@font-face {
		font-family: "theSans";
	    src:url("../../assets/fonts/thesans-b5plain.otf");
	    font-weight: normal;
	}
	@font-face {
		font-family: "theSans";
	    src:url("../../assets/fonts/thesans-b5plainitalic.otf");
	    font-weight: normal;
		font-style: italic;
	}
	@font-face {
		font-family: "theSans";
	    src:url("../../assets/fonts/thesans-b7bold.otf");
	    font-weight: bold;
	}

	#page {
		font-family: "theSans" !important;
	}

	.ql-editor {
		font-family: "theSans" !important;
	}

	.ecpPreview {

	}
	.ecpPreview .modal-card {
		height: auto;
	}

	.previewImage {
		display: block;
		max-height: calc(90vh - 100px);
	    width: auto;
	    margin: 0 auto;
		-webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
		-moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
		box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
	}

	.equipmentCatalogPage .filterBar {
		position: relative;
		z-index: 10;
		margin: 0 auto 25px auto;
		display: flex;
		flex-wrap: wrap;
	}
	.equipmentCatalogPage .filterBar > div {
		max-width: 250px;
	}
	.equipmentCatalogPage .filterBar > .control {
		margin: 0;
		/* z-index: 0;*/
		/*flex-basis: 100px;*/
	}
	.equipmentCatalogPage .filterBar > .control .switchery {
		margin-top: 5px;
	}

	.equipmentCatalogPage .filterBar > .control:not(:last-child) {
		margin-right: 8px;
	}
	.equipmentCatalogPage .filterBar > .control .control {
		width: 100%;
		margin: 0;
	}
	.equipmentCatalogPage .filterBar > .control > .control-label {
		margin: 0 !important;
		padding: 0 0 3px 0 !important;
		text-align: left !important;
	}


	@media all and (max-width: 1280px) {
		.equipmentCatalogPage .filterBar > .control:not(:last-child) {
			margin-bottom: 15px;
		}
	}

	.equipmentCatalogPage .section {
		position: relative;
		z-index:20;
		background: transparent;
		padding: 0;
		margin: 0 0 30px 0;
		min-height: 50px;
		transition: all .5s ease;
	}
	.equipmentCatalogPage .section > .section {
		margin-top: 25px;
		margin-bottom: 0;
	}
	.equipmentCatalogPage .section:last-child {
		margin-bottom: 0;
	}

	.equipmentCatalogPage .section.FULLSIZE_AD {
		position: absolute !important;
		left: -20.5mm;
        right: -20.5mm;
        /*top: -45.5mm;*/
		top: -41.5mm;
        bottom: -20.5mm;
	}
	.equipmentCatalogPage .section.FULLSIZE_AD .aside {
		left: calc(100% + 1mm) !important;
	}



</style>





<style scoped>

	.sortable-ghost {
		background: #fff;
	}


	.dragging {
		cursor: grabbing !important;
		cursor: -moz-grabbing !important;
		cursor: -webkit-grabbing !important;
	}

	.types  {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.types.templates > div {
		width: 31%;
		height: 30px;
	}
	.types > div {
		position: relative;
		width: 48%;
		height: 55px;
		background: #fff;
		border-radius: 3px;
		overflow: hidden;
		font-size: 10px;
		margin-bottom: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		border: 1px solid transparent;
		cursor: grab;
		transition: all .3s ease;
	}
	.types > div:hover {
		background-color: #f5f5f5;
	}


</style>
